import { api } from '../../../services/api/apiClient';
import { crudService } from '../../../services/api/crudService';
import type { ApiResponse } from '../../../types/api';
import type { DocPayment, Invoice, InvoiceInput } from '../types/invoiceTypes';

export const invoiceService = {
  ...crudService<Invoice, InvoiceInput>('/invoices'),
  /** Draft -> final: gives the invoice its number and posts it to the customer's account. */
  finalize: (id: string) => api.post<ApiResponse<Invoice>>(`/invoices/${id}/finalize`).then((r) => r.data),
  cancel: (id: string, reason: string) => api.post<ApiResponse<Invoice>>(`/invoices/${id}/cancel`, { reason }).then((r) => r.data),
  payments: (id: string) => api.get<ApiResponse<DocPayment[]>>(`/invoices/${id}/payments`).then((r) => r.data),
  openPdf: (id: string) => api.openPdf(`/invoices/${id}/pdf`),
};
